"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbDRPicasoAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const types_1 = require("../../../security/session/cc/types");
const config_1 = require("../../../security/azureCommons/config");
const store_1 = require("../../../store");
const helper_1 = require("../cc/helper");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
class MyKeycloakSession extends web_ui_security_1.KeycloakSession {
    doRefresh() {
        throw new Error('Method not implemented.');
    }
}
class MyAzureSession extends web_ui_security_1.AzureSession {
    doRefresh() {
        throw new Error('Method not implemented.');
    }
}
//TODO Authenticator only for model or not??
class MbDRPicasoAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, xhr, helper) {
        super(session);
        this.agentToken = '';
        this.agentRefreshToken = '';
        this.doLogout = async () => {
            const accessToken = this.getSession().getData()?.accessToken;
            await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/logout`, { accessToken });
        };
        this.doLogin = async (data) => {
            const loginResult = await this.helper.requestLogin(data);
            return {
                ...loginResult,
                agentToken: this.agentToken,
                agentRefreshToken: this.agentRefreshToken,
                username: data.username,
                timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(loginResult.expiresIn),
                entrypoint: types_1.EntrypointType.DRPicaso,
            };
        };
        this.loginAgent = async () => {
            const data = this.authSystem === 'AZURE' ? await this.loginAzure() : await this.loginKeycloak();
            return data;
        };
        this.loginAzure = async () => {
            await this.azure?.login(config_1.loginRequest);
            const data = this.azureSession?.getData();
            if (data) {
                this.agentToken = data.accessToken;
                this.agentRefreshToken = data.refreshToken;
                const sessionData = {
                    accessToken: '',
                    refreshToken: '',
                    agentRefreshToken: data.refreshToken,
                    agentToken: data.accessToken,
                    username: '',
                    expiresIn: data.expiresIn ?? 5000,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(data.expiresIn),
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.DRPicaso,
                };
                this.session.initSession(sessionData);
                return sessionData;
            }
            return null;
        };
        this.loginKeycloak = async () => {
            await this.keycloak?.init({
                checkLoginIframe: false,
                onLoad: 'login-required',
            });
            await this.keycloak?.login({});
            const data = this.keycloakSession?.getData();
            if (data) {
                this.agentToken = data.accessToken;
                this.agentRefreshToken = data.refreshToken;
                const sessionData = {
                    accessToken: '',
                    refreshToken: '',
                    agentRefreshToken: data.refreshToken,
                    agentToken: data.agentToken,
                    username: '',
                    expiresIn: data.expiresIn ?? 5000,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(data.expiresIn),
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.DRPicaso,
                };
                this.session.initSession(sessionData);
                return sessionData;
            }
            return null;
        };
        this.requestInteractionId = (param) => {
            return this.helper.requestInteractionId(param);
        };
        this.requestPasswordPosition = (param) => {
            return this.helper.requestPasswordPosition(param);
        };
        this.helper = helper;
        this.xhr = xhr;
        this.authSystem = window.AUTH_SYSTEM;
        if (this.authSystem === 'KEYCLOAK') {
            this.keycloakSession = new MyKeycloakSession((0, store_1.getDefaultMemoryStore)());
            this.keycloak = new web_ui_security_1.KeycloakAuthenticator(this.keycloakSession, {
                url: window.KEYCLOAK_AUTH_URL, // keycloak server
                realm: 'master',
                clientId: window.KEYCLOAK_AUTH_CLIENTID,
            });
        }
        else if (this.authSystem === 'AZURE') {
            this.azureSession = new MyAzureSession((0, store_1.getDefaultMemoryStore)());
            this.azure = new web_ui_security_1.AzureAd(this.azureSession, config_1.msalConfig);
        }
    }
}
exports.MbDRPicasoAuthenticator = MbDRPicasoAuthenticator;
//# sourceMappingURL=index.js.map